import React from "react";
import { Outlet } from "react-router-dom";

const WarehouseUserClientReportDaily: React.FC = () => {
  return <Outlet />;
};

export default WarehouseUserClientReportDaily;